<template>
  <div class="keyVisualWrapper" :style="styles" :class="addClass">
    <div :class="{ container: !noContainer }">
      <div class="visual-container">
        <img class="visual-image" :src="desktopImageUrl" :style="imageStyles" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "key-visual",
  props: {
    desktopImageUrl: {
      type: String,
      required: true
    },
    mobileImageUrl: {
      type: String,
      required: true
    },
    addRow: {
      type: Boolean
    },
    noContainer: {
      type: Boolean
    },
    mobileImgStyles: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object
    },
    addClass: {
      type: String
    },
    imageStyles: {
      type: Object
    }
  }
};
</script>

<style scoped lang="scss">
.visual-container {
  width: 100%;
  height: 100%;
}
.visual-image {
  max-width: 100%;
}
.trademark_visual {
  position: absolute;
  bottom: 0px;
  right: 8%;

  @media (max-width: 992px) {
    img {
      width: 60%;
    }
    right: 5%;
  }

   @media (max-width: 767px) {
    img {
      width: 40%;
    }
    right: -25%;
  }
}
</style>
